import axiosInstance from "../../../../shared/api/axiosInstance.js";
import { baseUrl, EDIT_GALLERY, DELETE_GALLERY } from "../../../../shared/api/endpoints.js";
import { configReq } from "../../../../shared/lib/functions.js";
/** Keeps the existing PUT request and response contract. */
export function editGallery(fd, token) {
  return axiosInstance.put(`${baseUrl}/${EDIT_GALLERY}`, fd, configReq(token));
}

/** Keeps the existing DELETE request and response contract. */
export function deleteGallery(prevData, token) {
  return axiosInstance.delete(`${baseUrl}/${DELETE_GALLERY}?id=${prevData.id}`, configReq(token));
}
